import { collapseUnchanged, diffLines, diffStats } from '@carrent/domain'

/**
 * Построчные изменения.
 *
 * Неизменные куски сворачиваются, вокруг правок остаётся контекст:
 * иначе в статье на двести строк правку из трёх пришлось бы искать
 * глазами.
 */
export function DiffView({ before, after, beforeLabel, afterLabel }) {
  const rows = diffLines(before, after)
  const { added, removed } = diffStats(rows)

  if (!added && !removed) {
    return <p className="diff__same">Текст не изменился.</p>
  }

  return (
    <div className="diff">
      <header className="diff__head">
        <span className="diff__labels">
          {beforeLabel} → {afterLabel}
        </span>
        <span className="diff__stats">
          <span className="diff__added">+{added}</span>
          <span className="diff__removed">−{removed}</span>
        </span>
      </header>

      <div className="diff__body">
        {collapseUnchanged(rows).map((row, i) => {
          if (row.type === 'gap') {
            return (
              <div key={i} className="diff__gap">
                ⋯ {row.count} {plural(row.count)} без изменений
              </div>
            )
          }
          return (
            <div key={i} className={`diff__line diff__line--${row.type}`}>
              <span className="diff__sign" aria-hidden="true">
                {row.type === 'add' ? '+' : row.type === 'remove' ? '−' : ' '}
              </span>
              <span className="diff__text">{row.text || '\u00a0'}</span>
            </div>
          )
        })}
      </div>
    </div>
  )
}

function plural(n) {
  const mod10 = n % 10
  const mod100 = n % 100
  if (mod10 === 1 && mod100 !== 11) return 'строка'
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return 'строки'
  return 'строк'
}
